"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var theme = require("../reportingHistory/theme.scss");
var MaterialIcon_1 = require("../../../../components/materialIcon/MaterialIcon");
var enums_1 = require("../../../../common/enums");
var ReportHistoryRow = /** @class */ (function (_super) {
    tslib_1.__extends(ReportHistoryRow, _super);
    function ReportHistoryRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onReuseReport = function () {
            _this.props.getReportFromReportingHistoryUrls(_this.props.item, enums_1.ReportHistoryUrlAction.Reuse);
        };
        _this.onReuseReportParams = function () {
            _this.props.setParamsFromHistoryReport(_this.props.item);
        };
        _this.onDownload = function () {
            _this.props.getReportFromReportingHistoryUrls(_this.props.item, enums_1.ReportHistoryUrlAction.Download);
        };
        _this.onEditDescription = function () {
            _this.props.setEditHistoryReport(_this.props.item);
        };
        return _this;
    }
    ReportHistoryRow.prototype._getColorByStatus = function () {
        var item = this.props.item;
        switch (item.status) {
            case enums_1.ReportHistoryStatus.Finished:
                return "var(--primary-success-color)";
            case enums_1.ReportHistoryStatus.Error:
                return "var(--primary-error-color)";
            case enums_1.ReportHistoryStatus.Processing:
                return "var(--primary-pending-color)";
        }
    };
    ReportHistoryRow.prototype.render = function () {
        var _a = this.props, item = _a.item, index = _a.index, columnsWidth = _a.columnsWidth, freezeColumnIndex = _a.freezeColumnIndex;
        return (React.createElement(ui_1.DataGridRow, { className: theme.row, index: index, columnsWidth: columnsWidth, key: item._id, freezeColumnIndex: freezeColumnIndex },
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, moment(item.created).format("MMM DD, YYYY")),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, item.duration),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, tooltip: true },
                React.createElement("div", { className: theme.links },
                    React.createElement(ui_1.LinkButton, { onClick: this.onEditDescription, iconName: "icon-edit", iconSize: 1.8 }),
                    React.createElement("div", { style: { marginLeft: 10 } }, item.description))),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, tooltip: true }, item.dimensions),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, tooltip: true }, item.metrics),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, tooltip: true }, item.filtersStr),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, tooltip: true }, item.constraintsStr),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, item.size),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, item.executionTime ? Math.ceil(item.executionTime / 1000) + "s" : 0),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, item.fileIds.length > 0 ? (React.createElement("div", { className: theme.links },
                React.createElement(ui_1.Tooltip, { title: "Reuse Params" },
                    React.createElement("span", { onClick: this.onReuseReportParams, className: theme.action },
                        React.createElement(MaterialIcon_1.default, { iconName: "settings_backup_restore", size: "1.8rem" }))),
                React.createElement(ui_1.Tooltip, { title: "Reuse Report" },
                    React.createElement("span", { onClick: this.onReuseReport, className: theme.action },
                        React.createElement(MaterialIcon_1.default, { iconName: "switch_access_shortcut", size: "1.8rem" }))),
                React.createElement(ui_1.Tooltip, { title: "Download Report" },
                    React.createElement("span", { onClick: this.onDownload, className: theme.action },
                        React.createElement(MaterialIcon_1.default, { iconName: "download", size: "1.8rem" }))))) : null),
            React.createElement(ui_1.DataGridColumn, { className: theme.column, style: { backgroundColor: this._getColorByStatus() } }, item.status)));
    };
    return ReportHistoryRow;
}(React.Component));
exports.default = ReportHistoryRow;
